import React, { useState, useEffect } from 'react';
import './JobSearchStartDateModal.css';

const JobSearchStartDateModal = ({ isOpen, onClose, onSave, currentDate }) => {
  const [startDate, setStartDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (currentDate) {
      setStartDate(currentDate);
    } else {
      // Default to 3 months ago
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      setStartDate(threeMonthsAgo.toISOString().split('T')[0]);
    }
  }, [currentDate, isOpen]);

  const handleSave = async () => {
    if (!startDate) {
      alert('Please select a date');
      return;
    }

    setIsLoading(true);
    try {
      await onSave(startDate);
      onClose();
    } catch (error) {
      console.error('Error saving start date:', error);
      alert('Failed to save date. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>When did you start your job search?</h2>
        <p className="modal-description">
          This date helps us determine how far back to scan your emails for job applications.
          We'll look for application emails from this date onwards.
        </p>
        
        <div className="form-group">
          <label htmlFor="start-date">Job Search Start Date:</label>
          <input
            type="date"
            id="start-date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            max={new Date().toISOString().split('T')[0]}
            className="date-input"
          />
        </div>

        <div className="date-info">
          {startDate && (
            <p>
              📅 We'll scan emails from <strong>{new Date(startDate).toLocaleDateString()}</strong> to today
              ({Math.floor((new Date() - new Date(startDate)) / (1000 * 60 * 60 * 24))} days)
            </p>
          )}
        </div>

        <div className="modal-actions">
          <button 
            onClick={onClose} 
            className="btn-secondary"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            className="btn-primary"
            disabled={isLoading || !startDate}
          >
            {isLoading ? 'Saving...' : 'Save & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobSearchStartDateModal;

